import axios from './axios'
import Bid from 'Models/Bid'
import { map, mapKeys, snakeCase } from 'lodash'
import BaseDataService from './BaseDataService'

function newBid (bid) {
  return new Bid(bid)
}

class Bids extends BaseDataService {
  async getAll (params) {
    params = mapKeys(params, (value, key) => snakeCase(key))
    return axios.get(`/bids`, { params })
      .then(response => map(response.data, newBid))
      .catch(console.error)
  }

  async cancelBid (bidId) {
    return axios.post(`/bids/${bidId}/cancel`)
      .then(response => newBid(response.data))
      .catch(console.error)
  }

  async rebid (bidId) {
    return axios.post(`/bids/${bidId}/rebid`)
      .then(response => newBid(response.data))
      .catch(console.error)
  }
}

export default new Bids()
